module.exports = __webpack_public_path__ + "img/211-poland.67193671.svg";